import http from './http'

/**
 * Activity Service
 * Handles all activity log API calls
 *
 * Uses B2B backend endpoints at /api/b2b/activity/*
 */

export interface ActivityLogEntry {
  id: string
  organization_id: string
  user_id: string
  action_type: string
  entity_type: string
  entity_id?: string
  description: string
  metadata?: Record<string, any>
  created_at: string
}

export interface ActivityLogFilters {
  action_type?: string
  entity_type?: string
  limit?: number
  offset?: number
}

class ActivityService {
  /**
   * Get organization activity log (admin/editor only)
   * GET /api/b2b/activity/log
   */
  async getActivityLog(filters?: ActivityLogFilters): Promise<ActivityLogEntry[]> {
    console.log('[ActivityService.getActivityLog] Fetching activity log')
    try {
      const response = await http.get<ActivityLogEntry[]>('/api/b2b/activity/log', {
        params: filters
      })
      console.log('[ActivityService.getActivityLog] Fetched', response.data.length, 'entries')
      return response.data
    } catch (error: any) {
      console.error('[ActivityService.getActivityLog] Failed:', error)
      throw this.handleError(error)
    }
  }

  /**
   * Get current user's activity log
   * GET /api/b2b/activity/log/me
   */
  async getMyActivity(filters?: ActivityLogFilters): Promise<ActivityLogEntry[]> {
    console.log('[ActivityService.getMyActivity] Fetching my activity')
    try {
      const response = await http.get<ActivityLogEntry[]>('/api/b2b/activity/log/me', {
        params: filters
      })
      return response.data
    } catch (error: any) {
      console.error('[ActivityService.getMyActivity] Failed:', error)
      throw this.handleError(error)
    }
  }

  /**
   * Get recent activity for dashboard
   */
  async getRecentActivity(limit: number = 10): Promise<ActivityLogEntry[]> {
    console.log('[ActivityService.getRecentActivity] Fetching recent activity')
    return this.getActivityLog({ limit })
  }

  /**
   * Error handler
   */
  private handleError(error: any): Error {
    if (error.response) {
      const message = error.response.data?.message || error.response.data?.detail || error.response.data?.error || 'An error occurred'
      const customError = new Error(message)
      ;(customError as any).status = error.response.status
      ;(customError as any).data = error.response.data
      return customError
    } else if (error.request) {
      return new Error('Network error. Please check your connection.')
    } else {
      return new Error(error.message || 'An unexpected error occurred')
    }
  }
}

export default new ActivityService()
